import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Register from "./pages/Register";
import Login from "./pages/Login";
import QuizCategories from "./components/QuizCategories";
import TopicsList from "./components/TopicsList";
import QuizPage from "./components/QuizPage";
import QuizGenerator from "./components/QuizGenerator";
import ProtectedRoute from "./components/ProtectedRoute";
import TakeQuiz from "./components/TakeQuiz";
import QuizPlayer from "./components/QuizPlayer";
import Feedback from "./components/Feedback";
import ModeSelection from "./components/ModeSelection"; // Import ModeSelection
import VerifyEmail from "./pages/VerifyEmail";
import LandingQuizGenerator from "./components/LandingQuizGenerator";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import QuizUploadPage from "./components/QuizUploadPage";
import UserProfile from "./components/UserProfile";
import AdminPage from "./components/AdminPage";
import PendingQuizSave from "./components/PendingQuizSave";
import { useAuth } from "./context/AuthContext";
import { Navigate } from "react-router-dom";
import PushSubscriptionSync from "./components/PushSubscriptionSync";
import DailyQuiz from "./components/DailyQuiz";
import QuizNotificationSettings from "./components/QuizNotificationSettings";
import { Container, Paper } from "@mui/material";
import GoogleAnalyticsTracker from './pages/GoogleAnalyticsTracker';


function AdminRoute() {
    const { user } = useAuth();
    return user?.role === "admin" ? <AdminPage /> : <Navigate to="/categories" replace />;
}

function App() {
    return (
        <AuthProvider>
            <Router>
      {/* Google Analytics Tracker placed correctly */}
                <GoogleAnalyticsTracker />
                <PushSubscriptionSync />
                <Routes>
                    <Route path="/finish-save" element={<ProtectedRoute><PendingQuizSave /></ProtectedRoute>} />
                    <Route path="/admin" element={<ProtectedRoute><AdminRoute /></ProtectedRoute>} />
    
                {/*<Route path="/" element={<Login />} />*/}
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/take-quiz" element={<TakeQuiz />} />
                    <Route path="/verify-email" element={<VerifyEmail />} />
                    <Route path="/" element={<LandingQuizGenerator />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
                   <Route path="/terms" element={<TermsPage />} />
                   <Route path="/privacy" element={<PrivacyPolicyPage />} />



                   
                     {/* Categories Route */}
                    <Route path="/quiz/daily/:sessionId" element={<ProtectedRoute><DailyQuiz /></ProtectedRoute>} />
                    <Route path="/notifications" element={<ProtectedRoute><Container maxWidth="sm" sx={{ mt: 4 }}><Paper elevation={3} sx={{ p: 4 }}><QuizNotificationSettings /></Paper></Container></ProtectedRoute>} />
                    <Route path="/profile" element={
                        <ProtectedRoute>
                            <UserProfile />
                        </ProtectedRoute>
                    } />

                      {/* Categories Route */}
                    <Route path="/uploadquiz" element={
                        <ProtectedRoute>
                            <QuizUploadPage />
                        </ProtectedRoute>
                    } />
                    
                      {/* Categories Route */}
                    <Route path="/generate_quiz" element={
                        <ProtectedRoute>
                            <QuizGenerator />
                        </ProtectedRoute>
                    } />
                    
                    {/* Categories Route */}
                    <Route path="/categories" element={
                        <ProtectedRoute>
                            <QuizCategories />
                        </ProtectedRoute>
                    } />

                    {/* Topics Route */}
                    <Route path="/topics/:categoryId" element={
                        <ProtectedRoute>
                            <TopicsList />
                        </ProtectedRoute>
                    } />

                    {/* Mode Selection Route */}
                    <Route path="/mode/:topicId" element={
                        <ProtectedRoute>
                            <ModeSelection />
                        </ProtectedRoute>
                    } />

                    {/* Different Quiz Modes */}
                    <Route path="/quiz/:topicId" element={
                        <ProtectedRoute>
                            <QuizPage />
                        </ProtectedRoute>
                    } />

                    <Route path="/quiz/gamified/:topicId" element={
                        <ProtectedRoute>
                            <QuizPlayer />
                        </ProtectedRoute>
                    } />

                    <Route path="/quiz/interactive/:topicId" element={
                        <ProtectedRoute>
                            <Feedback />
                        </ProtectedRoute>
                    } />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;
